<template>
    <div class="top-bar-wrapper" id="top-bar">
        <div class="top-bar">
            <div class="top-bar-left">
                <router-link :to="{name: 'Index'}" class="logo">
                    <Logo/>
                </router-link>
                <ul class="top-nav">
                    <li><a href='/#about'><span v-html="$ml.with('VueJS').get('aboutService')"></span></a></li>
                    <li><a href="/#functional"><span v-html="$ml.with('VueJS').get('functional')"></span></a></li>
                    <li><a href="/#subscription"><span v-html="$ml.with('VueJS').get('subscription')"></span></a></li>
                    <li><a href="/#contacts"><span v-html="$ml.with('VueJS').get('contacts')"></span></a></li>
                </ul>
            </div>

            <div class="top-bar-right">


                <div class="user-info-block">

                    <router-link v-if="user.role === roleAdmin" :to="{name:'Profile'}" class="user-info">
                        <div class="name">{{user.surname}} {{user.name}}<br> {{user.patronymic}}</div>
                        <div class="position" v-html="$ml.with('VueJS').get('admin')"></div>
                    </router-link>
                    <router-link v-else :to="{name: 'ClientProfile'}" class="user-info">
                        <div class="name">{{user.name}} {{user.patronymic}}<br> {{user.surname}}</div>
                    </router-link>

                    <div class="btn-exit" @click="logout">
                        <Logout/>
                    </div>
                </div>


                <div class="menu-toggler">
                    <MenuToggler/>


                    <div class="nav-mob-wrapper">
                        <ul class="nav-mob user-menu">

                            <li class="btn-link" v-if="user.role === roleClient">
                                <router-link :to="{name:'MailCreate'}">
                                <span class="icon">
                                    <PlusIcon/>
                                </span>
                                    <span class="text" v-html="$ml.with('VueJS').get('newMail')"></span>
                                </router-link>
                            </li>
                            <li class="divider" v-if="user.role === roleClient"></li>

                            <div v-if="user.role === roleClient">
                                <ClientNavigationItems/>
                            </div>
                            <div v-else>
                                <AdminNavigationItems/>
                            </div>

                            <li class="divider"></li>

                            <li>
                                <a href="/#about">
                    <span class="icon">
                        <Dot/>
                    </span>
                                    <span v-html="$ml.with('VueJS').get('aboutService')"></span></a></li>
                            <li><a href="/#functional">
                    <span class="icon">
                        <Dot/>
                    </span>
                                <span v-html="$ml.with('VueJS').get('functional')"></span></a></li>
                            <li><a href="/#subscription">
                    <span class="icon">
                        <Dot/>
                    </span>
                                <span v-html="$ml.with('VueJS').get('subscription')"></span></a></li>
                            <li><a href="/#contacts">
                    <span class="icon">
                        <Dot/>
                    </span>
                                <span v-html="$ml.with('VueJS').get('contacts')"></span></a></li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import Logo from "./icons/Logo";
    import Logout from "./icons/LogoutIcon";
    import MenuToggler from "./icons/MenuTogglerIcon";
    import Dot from "./icons/DotIcon";
    import ProfileIcon from "./icons/ProfileIcon";
    import ClientsIcon from "./icons/ClientsIcon";
    import MailIcon from "./icons/MailIcon";
    import ClientNavigationItems from "./ClientNavigationItems";
    import AdminNavigationItems from "./AdminNavigationItems";
    import constants from '../constants'
    import PlusIcon from "@/components/icons/PlusIcon";

    export default {
        components: {
            PlusIcon,
            AdminNavigationItems,
            ClientNavigationItems, MailIcon, ClientsIcon, ProfileIcon, Dot, MenuToggler, Logout, Logo, constants
        },

        data() {
            return {
                user: {},
                roleClient: '',
                roleAdmin: ''
            }
        },

        mounted() {
            // nav
            $('.menu-toggler').click(function () {
                $('.nav-mob-wrapper').fadeToggle(200);
            });
            $('.nav-mob-wrapper a').click(function (event) {
                event.stopPropagation();
                $('.nav-mob-wrapper').fadeOut(200);
            });

            $(document).mouseup(function (e) {
                var container = $('.menu-toggler');
                if (container.has(e.target).length === 0) {
                    // container.hide();
                    $('.nav-mob-wrapper').hide();
                }
            });
        },

        created() {
            this.user = this.$store.getters.currentUser;
            this.roleClient = constants.ROLE.CLIENT;
            this.roleAdmin = constants.ROLE.ADMIN;

        },

        methods: {
            logout() {
                this.$store.dispatch('logout');
                this.$router.push({name: 'Index'});

            }
        }
    }
</script>